<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje opinie końcowe</h2>
		</v-card-title>
		<final-evaluation-table/>
	</div>
</template>

<script>
	import FinalEvaluationTable from "./FinalEvaluationTable";

	export default {
		name: "FinalEvaluationList",
		components: {FinalEvaluationTable}
	};
</script>

<style scoped>

</style>